<template>
  <footer class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-10">:denisecko:</div>
        <div class="col"></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>
